import { cancelledBookings } from '@assets/icons'
import Table from '@components/table'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { useModal } from '@context/ModalContext'
import { Booking } from '@apis'
import Row from '@components/row'
import { Circle } from '@commons/cards/profile/style'
import Column from '@components/column'
import theme from '@utils/theme'
import { CircleCheck, Eye } from 'lucide-react'
import CancellationStatusUpdateModal from '@commons/cancellation-status-alert'

const CancellationRequest = ({
  user,
  providerId,
}: {
  user?: any
  providerId?: number
}) => {
  const {
    items: bookings = [],
    loading,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.bookings)
  const [page, setPage] = useState(1)
  const { showModal } = useModal()
  const fetchBookings = async () => {
    await Booking.list({
      state: 'bookings',
      params: {
        status: 'Cancelled',
        page,
        limit: 20,
      },
    })
      .then(() => {})
      .catch(() => {})
  }

  useEffect(() => {
    fetchBookings().then(() => {})
  }, [])
  const columns = [
    {
      title: 'Booking Id',
      key: 'bookingId',
      render: (item: any) => <>{item.id}</>,
    },
    {
      title: 'User Detail',
      key: 'userDetail',
      render: (item: any) => {
        const person = item.infos?.contactPerson
        const initial =
          typeof person === 'string' && person.length > 0
            ? person.charAt(0).toUpperCase()
            : '?'

        return (
          <Row styleRow="align-items: center; gap: 8px">
            <Circle size={40}>{initial}</Circle>
            <Column stylecolumn="gap: 0">
              <p>{person ?? '-'}</p>
              <p>{item.infos?.contactNo ?? '-'}</p>
            </Column>
          </Row>
        )
      },
    },
    {
      title: 'Bus Provider',
      key: 'busProvider',
      render: (item: any) => (
        <>
          <p>{item.schedule.vehicle.name}</p>
          <p>{item.schedule.vehicle.number}</p>
        </>
      ),
    },
    {
      title: 'Travel Route',
      key: 'travelRoute',
      render: (item: any) => (
        <>
          <p>{item.boardingPoint.name}</p>
          <p>{item.dropOffPoint.name}</p>
        </>
      ),
    },
    {
      title: 'Seat Detail',
      key: 'seatDetail',
      render: (item: any) => {
        // Group seats into rows of 2
        const rows: any[] = []
        const seatsPerRow = 2
        for (let i = 0; i < item.bookingSeats.length; i += seatsPerRow) {
          rows.push(item.bookingSeats.slice(i, i + seatsPerRow))
        }

        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: '10px',
                // border: `1px solid ${theme.colors.primary}`,
                borderRadius: '12px',
                padding: '12px',
                // backgroundColor: '#f9f9f9',
              }}
            >
              {rows.map((row, rowIndex) => (
                <div
                  key={rowIndex}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    gap: '12px', // space between seats
                  }}
                >
                  {row.map((seat: any) => (
                    <div
                      key={seat.id}
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '6px',
                        backgroundColor: theme.colors.primaryLight || '#e0f0ff',
                        color: theme.colors.primary,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '12px',
                        fontWeight: 500,
                        padding: '2px',
                      }}
                    >
                      <span>{seat.seat}</span>
                      <span
                        style={{
                          fontSize: '8px',
                          color: theme.colors.primaryDark,
                        }}
                      >
                        {seat.type}
                      </span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )
      },
    },
    {
      title: 'Travel Date',
      key: 'travelDate',
      render: (item: any) => <>{item.date}</>,
    },
    {
      title: 'Total Fare',
      key: 'totalFare',
      render: (item: any) => <>Rs. {item.schedule.price}</>,
    },
  ]
  return (
    <Table
      columns={columns}
      data={bookings}
      text="Cancelled Bookings"
      icon={cancelledBookings}
      totalItems={totalItems}
      totalPages={totalPages}
      loading={loading}
      itemsPerPage={20}
      pageControlled={page}
      onPageChange={setPage}
      actions={[
        {
          key: 'view',
          icon: <Eye width={10} color={theme.colors.primary} />,
          onClick: (item) => {
            showModal(
              <CancellationStatusUpdateModal item={item} variant={'both'} />,
            )
          },
        },
        {
          key: 'accept',
          icon: <CircleCheck color={'#4caf4f'} width={10} />,
          onClick: (item) => {
            showModal(
              <CancellationStatusUpdateModal item={item} variant={'accept'} />,
            )
          },
        },
        // {
        //   key: 'reject',
        //   icon: <CircleX color="#e72929" width={12} />,
        //   onClick: (item) => {
        //     showModal(
        //       <CancellationStatusUpdateModal item={item} variant={'reject'} />,
        //     )
        //   },
        // },
      ]}
      hasExportButton={true}
      savedTitle="cancelledbookings.pdf"
    />
  )
}

export default CancellationRequest
